import { put, takeLeading, select } from 'redux-saga/effects';
import { isEmpty, get, isNull } from 'lodash';
import { callApi } from 'helpers/saga-helpers';
import userToken from 'containers/services/security/access-token-storage';
import { setManagerPendingClaims } from 'containers/ManagerPendingClaims/actions';
import {
  setFoundClaims,
  setSearchClaims,
} from 'containers/IdentificationPage/actions';
import { makeSelectKeycloakToken } from 'containers/AppContainer/selectors';
import {
  REQUEST_SEARCH_CLAIMS,
  REQUEST_SEARCH_PANDING_CLAIMS,
  SEND_EXISTING_CLAIMS_AND_DOCUMENT,
} from 'containers/IdentificationPage/constants';
import { requestSearchClaims as requestSeachClaimsAction } from 'containers/IdentificationPage/actions';
import { SearchQuery } from 'containers/IdentificationPage/typings';

export interface ISearchAction {
  type: string;
  searchQuery: SearchQuery;
}

export function* searchClaims(action: ISearchAction): Generator<unknown> {
  const isEdit = get(action, 'searchQuery.isEdit');
  const token = get(userToken.get(), 'token')
    ? get(userToken.get(), 'token')
    : yield select(makeSelectKeycloakToken());
  if (isNull(token)) return;
  const path = get(userToken.get(), 'token')
    ? '/corporeal/common/search-claim'
    : '/corporeal/common/search-claim?isIntervenant=true';

  const options = {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ...action.searchQuery, withoutCanceledClaims: 'Y' }),
  };
  yield callApi(
    path,
    {},
    options,
    [],
    !isEdit ? setSearchClaims : setFoundClaims,
  );
}

export function* requestSearchClaims() {
  yield takeLeading(REQUEST_SEARCH_CLAIMS, searchClaims);
}

export function* findClaims(action: ISearchAction): Generator<unknown> {
  const token = get(userToken.get(), 'token');
  const path = '/corporeal/common/find-claim';
  if (isNull(token)) return;
  const options = {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(action.searchQuery),
  };
  yield callApi(path, [], options, [], setManagerPendingClaims(true));
}

export function* requestFindClaims() {
  yield takeLeading(REQUEST_SEARCH_PANDING_CLAIMS, findClaims);
}

export function* sendExistingClaimAndDocument(action: any): Generator<unknown> {
  const path = '/corporeal/common/upload-existant-claim-documents';
  const token = yield select(makeSelectKeycloakToken());
  if (!token) return;

  const { callback, payload } = action;
  const options = {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  };

  const errorResponse = yield callApi(path, {}, options, []);

  if (!errorResponse) {
    yield callback();

    if (!isEmpty(payload.claim)) {
      const { lossDate, policyNumber, registrationNumber } = payload.claim;

      yield put(
        requestSeachClaimsAction({
          lossDate,
          policyNumber,
          registrationNumber,
        }),
      );
    }
  }
}

export function* sendExistingClaimAndDocumentSaga() {
  yield takeLeading(
    SEND_EXISTING_CLAIMS_AND_DOCUMENT,
    sendExistingClaimAndDocument,
  );
}

export default [
  requestSearchClaims,
  requestFindClaims,
  sendExistingClaimAndDocumentSaga,
];
